import React from "react";
import { categories } from "../utils/constants";
import { Box } from "@mui/material";

const Sidebar = ({selectedCategory, setSelectedCategory}) => {
    
    return (
    <Box
      p={2}
      sx={{
        display: "flex",
        height: {sx: 'auto', md: '90%'},
        flexDirection: { md: "column" },
        overflowY: 'auto',
      }}
    >
      {categories.map((category, i) => (
          <button
            key={i}
            className="category-btn"
            onClick={(e) => setSelectedCategory(category.name)}
            style={{
              color: "#850E35",
              backgroundColor: category.name === selectedCategory && '#850E35'
            }}
          >
            <span style={{
              marginRight: '15px',
              color: selectedCategory === category.name ? 'white' : ''
              }}>{category.name}</span>
            <span 
              style={{color: selectedCategory === category.name ? 'white' : ''}}
            > {category.icon}</span>
          </button>

      ))}
    </Box>
  );
};

export default Sidebar;
